/* DHC v1053.25 B99 — reveal mobile sticky ATC only after the shopper passes the real ATC. */
(function(){
  'use strict';
  function boot(root){
    var scope=root||document;
    var pdp=scope.querySelector ? scope.querySelector('.dhc-pdp-v931') : null;
    if(!pdp) pdp=document.querySelector('.dhc-pdp-v931');
    if(!pdp || pdp.dataset.dhcB99StickyReady==='1') return;
    pdp.dataset.dhcB99StickyReady='1';
    var sticky=document.querySelector('[data-dhc-sticky-atc]');
    var primary=pdp.querySelector('[data-dhc-pdp-add]');
    if(!sticky || !primary) return;

    function update(){
      if(!window.matchMedia('(max-width: 749px)').matches){
        sticky.classList.remove('dhc-b99-is-visible');
        return;
      }
      var r=primary.getBoundingClientRect();
      /* Never show while the real purchase controls are still below or on screen.
         Reveal only after the shopper has scrolled past them. */
      var passed=r.bottom < 0;
      sticky.classList.toggle('dhc-b99-is-visible',passed);
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    document.addEventListener('shopify:section:load',update);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});
  else boot(document);
})();
